<div class="preview-element">
    <app-image src="assets/img/movie-film-roll.svg"></app-image>
</div>
